import React, { useEffect, useState } from "react";
import { Collapse, Tooltip, Tag } from "antd";
import { getQuestionDraftData, answerByCM } from "../../API/api";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import ImageResize from "quill-image-resize-module-react";
import { Modal, ModalHeader } from "react-bootstrap";
import { useSelector } from "react-redux";
import { CloseCircleOutlined } from "@ant-design/icons";
import { Checkbox } from 'antd';
import TooltipComp from "../../NewComponent/ToolTip/TooltipComp";
import InternalIcon from '../../Icons/internal.svg'
const textStyles = {
 fontSize: "16px",
 color: "#2A364A",
 lineHeight: "22px",
 fontWeight: "300",
 display: 'flex',
 alignItems: "center",
};
export default function AddAnswer({ questionId, reload, isDisable }) {
 const [isOpen, setIsOpen] = useState(false);
 const [answertext, setAnswerText] = useState('');
 const [privacy, setPrivacy] = useState(false);
 const [internal, setInternal] = useState(false);
 const [active, setActive] = useState('');
 const [attachment, setAttachments] = useState([]);
 const state = useSelector(state => state.expertRecord.clickedData)
 const fetchDraftData = () => {
   getQuestionDraftData(atob(questionId)).then((res) => {
     if (res === undefined) return;
     if (res.data.success) {
       if (res.data.data.length > 0) {
         setAnswerText(res.data.data[0].answer);
         setInternal(res.data.data[0].usageAccess === undefined ? false : res.data.data[0].usageAccess === 'internal' ? true : false);
       }
     }


   });
 };
 useEffect(() => {
   fetchDraftData();
 }, []);
 const label = () => {
   return (
     <span
       style={{ color: "var(--light_color_shade)", fontWeight: "300" }}
     >
       {isOpen ? <i className="fa fa-minus-circle" ></i> : <i className="fa fa-plus-circle" ></i>}&nbsp;
       {state.userInitiatedCuration ? <span>Update the Answer <i className="fa fa-info-circle"></i></span> : 'Add an Answer'}
     </span>
   );
 };
 const modules = {
   toolbar: [
     ["bold", "italic", "underline", "strike", "blockquote"],
     [{ list: "ordered" }, { list: "bullet" }],
     ["link", "image"],
   ],
   clipboard: {
     matchVisual: false,
   },
   imageResize: {
     parchment: Quill.import("parchment"),
     modules: ["Resize", "DisplaySize"],
   },
 };
 const formats = [
   "bold",
   "italic",
   "underline",
   "strike",
   "blockquote",
   "list",
   "bullet",
   "link",
   "image",
 ];
 const getBase64 = (file, cb) => {
   let reader = new FileReader();
   reader.readAsDataURL(file);
   reader.onload = function () {
     cb(reader.result)
   };
   reader.onerror = function (error) {
   };
 }
 const attachmentsData = (file) => {
   getBase64(file, (result) => {
     var size =
       file.size / (1024 * 1024) > 1
         ? file.size / (1024 * 1024) + " mB"
         : file.size / 1024 + " kB";
     let data = {
       caption: "",
       name: file.name,
       size: size,
       type: file.type,
       src: result,
       show: 1,
       isThumbNail: false,
     };
     setAttachments([...attachment, data]);
   })
 }
 const submitAns = () => {
   let payload = { ...state };
   payload.answerText = answertext;
   payload.cmAnswerText = answertext;
   payload.internal = !internal ? undefined : true;
   payload.cmAnswerInternal = !internal ? undefined : true;
   payload.privacy = !privacy ? undefined : true;
   payload.cmAnswerPrivacy = !privacy ? undefined : true;
   payload.uplodedFiles = attachment.length === 0 ? undefined : attachment;
   payload.cmuplodedFiles = attachment.length === 0 ? undefined : attachment;
   payload.tags = undefined;
   payload.answersList = [];
   setActive("");
   setIsOpen(false);
   answerByCM(payload).then(res => {
     reload('hg');
     isDisable(false)
   })
 }
 const isDisabled = (text) => {
   var regex = /(<([^>]+)>)/ig;
   var result = text?.replace(regex, "");
   return result;
 }
 const writeAnswer = () => {
   return (
     <div>
       <input type="file" id="actual-btn3" onChange={(e) => attachmentsData(e?.target?.files[0])} style={{ display: "none" }} name="files" required="" maxsize="500" aria-invalid="true"></input>
       <label for="actual-btn3">
         <i className="fa fa-paperclip"
           style={{
             position: "absolute",
             marginLeft: "315px",
             marginTop: "22px",
             color: "#434343",
             fontSize: "16px",
             fontWeight: "bold",
             cursor: "pointer",
           }}


         ></i>
       </label>
       <ReactQuill
         theme="snow"
         value={answertext}
         modules={modules}
         formats={formats}
         onChange={(e) => setAnswerText(e)}
       />
       <div
         style={{ display: "flex", paddingBlock: "5px", marginTop: "0px" }}
       >
         <div style={{ width: "20%", textAlign: "start" }}>
           {attachment.length > 0 && attachment.map(obj => {
             return (
               <Tag closeIcon={<CloseCircleOutlined />} closable onClose={(e) => {
                 e.preventDefault();
                 setAttachments(attachment.filter(ob => {
                   return obj.name !== ob.name;
                 }))
               }}>{obj.name}</Tag>
             )
           })}
         </div>
         <div style={{ width: "80%", display: 'flex', justifyContent: 'end', alignItems: 'center' }}>
           <div style={textStyles}>
             <Checkbox checked={internal} type="checkbox" onChange={(e) => setInternal(e.target.checked)} />&nbsp;
             <img src={InternalIcon} />&nbsp;Internal Only&nbsp;
             {/* <span style={textStyles}>
                 Internal Only
             </span> */}
             {/* <Internal/> */}
             <TooltipComp title="This QA pair will be visible only to Employees and not to Customers & Partners." >
               <i className='fa fa-question-circle tooltip-topics-b' ></i>
             </TooltipComp>


           </div>&nbsp;&nbsp;&nbsp;&nbsp;
           <div style={textStyles}>
             <Checkbox onChange={(e) => setPrivacy(e.target.checked)}
               checked={privacy} type="checkbox" />&nbsp;
             <i className="fa fa-lock"></i>&nbsp;Private Answer&nbsp;
             <TooltipComp title='This answer will be visible only to the Seeker who asked the question, and to all Experts.'>
               <i className='fa fa-question-circle tooltip-topics-b'></i>
             </TooltipComp>
           </div>
        
         </div>
       </div>
       <div style={{ textAlign: 'end' }}>
         <button
           style={{
             padding: '8px 12px 8px 12px',
             borderRadius: '6px',
             fontSize: '14px',
             lineHeight: '24px',
             fontWeight: 400,
             boxShadow: ' 0px 1px 2px 0px #1018280D',
             color: '#2A364A',
             border: '1px solid  #fff',
             height: '40px',
             minWidth: '88px',
             background: " #F6F7F8",
             marginBottom: '14px',
             fontWeight: 400,
             border: " 1px solid #E0E2E6"


             //  font-weight: 400;    
           }}
           onClick={() => {
             setActive('');
             setIsOpen(false);
           }}>Cancel</button>&nbsp;&nbsp;
         <button
           style={{
             padding: '8px 12px 8px 12px',
             borderRadius: '6px',
             fontSize: '14px',
             lineHeight: '24px',
             fontWeight: 400,
             boxShadow: '0px 1px 2px 0px #1018280D',
             color: '#FFFFFF',
             border: '1px solid  #fff',
             height: '40px',
             minWidth: '88px',
             background: 'linear-gradient(90.39deg, #00D1FF 0.34%, #0075FF 99.7%)',
             marginBottom: '14px',
             cursor: isDisabled(answertext) === "" ? "not-allowed" : "pointer",
             opacity: isDisabled(answertext) === "" ? "0.7" : "",
           }}
           onClick={() => submitAns()} disabled={isDisabled(answertext) === "" ? true : false}>Submit</button>
       </div>
     </div>
   );
 };
 return (
   <div className="mt-3">
     <Collapse
       showArrow={false}
       style={{
         background: "#fff",
         borderColor: "#F0F0F0",
         fontWeight: "100",
         fontSize: "15px",
       }}
       activeKey={active}
       onChange={(e) => {
         setIsOpen(!isOpen)
         setActive(e)
       }}
       items={[
         {
           key: "1",
           label: label(),
           children: writeAnswer(),
           showArrow: false,
         },
       ]}
     />
   </div>
 );
}
